import ApiService from "@/core/services/ApiService";
import JwtService from "@/core/services/JwtService";
import { Actions, Mutations } from "@/store/enums/StoreEnums";
import { Module, Action, Mutation, VuexModule } from "vuex-module-decorators";

export interface ActivityLogs {
  name: string;
  api_token: string;
}

export interface ActivityLogsListInfor {
  errors: unknown;
  activityLogs: ActivityLogs;
  isAuthenticated: boolean;
}

@Module
export default class ActivityLogsModule
  extends VuexModule
  implements ActivityLogsListInfor
{
  errors = {};
  activityLogs = {} as ActivityLogs;
  exportActivityLogs = {};
  isAuthenticated = !!JwtService.getToken();

  get ActivityLogs() {
    return this.activityLogsListData;
  }

  get getExportActivityLogsData() {
    return this.exportActivityLogs;
  }

  @Mutation
  [Mutations.ACTIVITY_LOGSES_LIST_DATA](ActivityLogs) {
    this.activityLogsListData = ActivityLogs;
  }

  @Mutation
  [Mutations.EXPORT_ACTIVITY_LOGS_LIST_DATA](exportActivityLogs) {
    this.exportActivityLogs = exportActivityLogs;
  }

  @Action
  [Actions.ACTIVITY_LOGSES_LIST](payload) {
    if (JwtService.getToken()) {
      ApiService.setHeader();
      return ApiService.post("activity_logs", payload)
        .then((data) => {
          this.context.commit(Mutations.ACTIVITY_LOGSES_LIST_DATA, data);
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.PURE_AUTH_AND_SET_ERROR, response.data);
        });
    } else {
      this.context.commit(Mutations.PURGE_AUTH);
    }
  }

  @Action
  [Actions.EXPORT_ACTIVITY_LOGS_LIST](payload) {
    if (JwtService.getToken()) {
      ApiService.setHeader("", "blob" as ResponseType);
      return ApiService.post("activity_logs/export", payload)
        .then((data) => {
          this.context.commit(Mutations.EXPORT_ACTIVITY_LOGS_LIST_DATA, data);
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.PURE_AUTH_AND_SET_ERROR, response.data);
        });
    } else {
      this.context.commit(Mutations.PURGE_AUTH);
    }
  }
}
